import { Box, Card } from '@zillow/constellation-10';
import { LoadingTag, LoadingText } from '@zg-rentals/loading-components';

type CreditClimbCardSkeletonProps = {
  isExtraSmallScreen?: boolean;
};

export const CreditClimbCardSkeleton = ({ isExtraSmallScreen = false }: CreditClimbCardSkeletonProps) => {
  if (isExtraSmallScreen) {
    return (
      <Card
        elevated={false}
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 'loose',
          gap: 'tighter',
        }}
        data-testid="CreditClimbCardSkeleton-Mobile"
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <LoadingText isLoading loadingWidth="30%">
            Loading
          </LoadingText>
          <LoadingTag isLoading loadingWidth="40%">
            Tag
          </LoadingTag>
        </Box>

        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'tighter',
            marginTop: 'tighter',
          }}
        >
          <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'default' }}>
            {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 150px` falls between `3600` (144px) and `4000` (160px) on the numeric sizes scale */}
            <LoadingText isLoading loadingWidth="33%" css={{ fontSize: '44px', height: '150px' }}>
              Loading
            </LoadingText>
            <LoadingText isLoading loadingWidth="80%">
              Loading
            </LoadingText>
            <LoadingText isLoading loadingWidth="80%">
              Loading
            </LoadingText>
          </Box>
          <LoadingText isLoading loadingWidth="45%">
            Loading
          </LoadingText>
        </Box>
      </Card>
    );
  }

  // Horizontal layout
  return (
    <Card
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: { base: '100%', lg: '270px' },
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 238px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
        minHeight: '238px',
        padding: 'loose',
      }}
      data-testid="CreditClimbCardSkeleton-Desktop"
    >
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <LoadingText isLoading loadingWidth="30%">
          Loading
        </LoadingText>
        <LoadingTag isLoading loadingWidth="55%">
          Tag
        </LoadingTag>
      </Box>

      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'tighter',
          marginTop: 'tighter',
        }}
      >
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center',
            gap: 'loose',
            marginTop: 'tighter',
          }}
        >
          {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 110px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale */}
          <LoadingText isLoading loadingWidth="40%" css={{ fontSize: '44px', height: '110px' }}>
            Loading
          </LoadingText>
          {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 110px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale */}
          <LoadingText isLoading loadingWidth="40%" css={{ fontSize: '44px', height: '110px' }}>
            Loading
          </LoadingText>
        </Box>
        <LoadingText isLoading loadingWidth="70%">
          Loading
        </LoadingText>
        <LoadingText isLoading loadingWidth="35%">
          Loading
        </LoadingText>
      </Box>
    </Card>
  );
};
